(() => {
  const STORAGE_KEY = 'ppc-online-trainer-popup-seen-v1';
  const SHOW_DELAY_MS = 2500;
  const AUTO_CLOSE_MS = 9000;

  const currentPath = window.location.pathname.toLowerCase();

  const isOnlineTrainerPage =
    currentPath.includes('/collections/online-trainer') ||
    currentPath.includes('/products/ppc-online-trainer');

  if (isOnlineTrainerPage) {
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  const popup = document.getElementById('ppc-online-trainer-popup');

  if (!popup) {
    return;
  }

  const backdrop = popup.querySelector(
    '.ppc-online-trainer-popup__backdrop'
  );

  const closeButton = popup.querySelector(
    '.ppc-online-trainer-popup__close'
  );

  let autoCloseTimer = null;

  const hasSeenPopup = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const markPopupAsSeen = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      // Popup funktioniert auch ohne sessionStorage.
    }
  };

  const closePopup = () => {
    if (popup.hidden) {
      return;
    }

    popup.classList.remove('is-visible');

    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }

    setTimeout(() => {
      popup.hidden = true;
    }, 200);
  };

  const openPopup = () => {
    if (hasSeenPopup()) {
      return;
    }

    markPopupAsSeen();

    popup.hidden = false;

    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });

    autoCloseTimer = setTimeout(
      closePopup,
      AUTO_CLOSE_MS
    );
  };

  if (closeButton) {
    closeButton.addEventListener(
      'click',
      closePopup
    );
  }

  if (backdrop) {
    backdrop.addEventListener(
      'click',
      closePopup
    );
  }

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape' &&
        !popup.hidden
      ) {
        closePopup();
      }
    }
  );

  if (!hasSeenPopup()) {
    setTimeout(
      openPopup,
      SHOW_DELAY_MS
    );
  }
})();